import { IColumn, ITableRowData } from "../../components/data-table/data-table";

export const alertcaseColumns: IColumn[] = [
  {
    key: "alertcase_number",
    displayName: "AlertCase number",
    dataType: {
      type: "text",
    }
  },
  {
    key: "title",
    displayName: "Title",
    dataType: {
      type: "text",
    }
  },
  {
    key: "creation_date",
    displayName: "Creation date",
    dataType: {
      type: "dateTime",
    }
  },
  {
    key: "process_type",
    displayName: "Process type",
    dataType: {
      type: "text",
    }
  },
  {
    key: "domain_type",
    displayName: "Domain type",
    dataType: {
      type: "text",
    }
  },
  {
    key: "consolidate_on_entity_type",
    displayName: "Consolidation",
    sortable: false,
    dataType: {
      type: "text",
    }
  },
  {
    key: "current_stage_name",
    displayName: "Stage",
    dataType: {
      type: "text",
    }
  },
  {
    key: "created_by_name",
    displayName: "Created by",
    sortable: false,
    dataType: {
      type: "text",
    } 
  },
  {
    key: "last_changed_by_name",
    displayName: "Last changed by",
    sortable: false,
    dataType: {
      type: "text",
    }
  },
  {
    key: "state",
    displayName: "Status",
    dataType: {
      type: "text",
    }
  },
  {
    key: "assign_user",
    displayName: "Assign user",
    sortable: false,
    dataType: {
      type: "action",
      buttonText: "Assign",
      disabled: (rowData: ITableRowData) => rowData.state === "Active" && rowData.assigned_to,
    }
  }
];